module.exports = __webpack_public_path__ + "img/MATIC.22a75bb4.svg";